import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a767652"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mini-cart",
  id: "miniCartContainer"
}
const _hoisted_2 = {
  id: "cart",
  class: "cart_wrapper"
}
const _hoisted_3 = {
  key: 0,
  class: "cart_count"
}
const _hoisted_4 = { class: "mini-cart__close-wrapper" }
const _hoisted_5 = { class: "cart_list" }
const _hoisted_6 = { class: "cart__item-row" }
const _hoisted_7 = { class: "cart__image-column" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "cart__row" }
const _hoisted_11 = { class: "col cart__info-column" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "size" }
const _hoisted_14 = {
  key: 0,
  class: "price-wrapper"
}
const _hoisted_15 = { class: "quantity" }
const _hoisted_16 = { class: "price" }
const _hoisted_17 = {
  key: 1,
  class: "price-wrapper"
}
const _hoisted_18 = { class: "quantity" }
const _hoisted_19 = { class: "price" }
const _hoisted_20 = { class: "cart__price-column" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "cart_footer" }
const _hoisted_23 = { class: "cart_total" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cart_price" }, null, -1))
const _hoisted_25 = { class: "cart_buttons" }
const _hoisted_26 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "cart-icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMiniCart && _ctx.toggleMiniCart(...args)))
        })
      ]),
      (_ctx.hasItems)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.numberOfStandardItems), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ 'mini-cart__details': true, 'show': _ctx.isMiniCartOpen }),
      id: "miniCartWrap"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeMiniCart && _ctx.closeMiniCart(...args))),
          class: "mini-cart__close-icon"
        })
      ]),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standardItems, (row) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "cart_item",
            key: row.partNo
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  class: "image",
                  href: row.url
                }, [
                  _createElementVNode("img", {
                    src: row.imageUrl,
                    alt: "cart_thumb1"
                  }, null, 8, _hoisted_9)
                ], 8, _hoisted_8)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("a", {
                      class: "name",
                      href: row.url
                    }, _toDisplayString(row.name), 9, _hoisted_12),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(row.productSize), 1),
                    _createElementVNode("div", null, [
                      (!_ctx.hidePrices)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("p", _hoisted_15, _toDisplayString(row.unitType == 'kg' ? row.quantityBulkDisplay : row.quantity) + " x", 1),
                            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.showPricesAsB2b ? row.priceFormatted : row.priceIncVatFormatted), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("p", _hoisted_18, _toDisplayString(row.unitType == 'kg' ? row.quantityBulkDisplay : row.quantity), 1),
                            _createElementVNode("p", _hoisted_19, _toDisplayString(row.unitType == 'kg' ? _ctx.$t("Cart.Ton") : _ctx.$t("Cart.Bag")), 1)
                          ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.onRemove(row.partNo)),
                      class: "item_remove"
                    }, null, 8, _hoisted_21)
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_22, [
        _withDirectives(_createElementVNode("p", _hoisted_23, [
          _createTextVNode(_toDisplayString(_ctx.$t("Checkout.SubTotal")) + ": ", 1),
          _hoisted_24,
          _createTextVNode(_toDisplayString(_ctx.showPricesAsB2b ? _ctx.summary.itemsExlServices.amountFormatted : _ctx.summary.itemsExlServices.amountIncVatFormatted), 1)
        ], 512), [
          [_vShow, !_ctx.hidePrices]
        ]),
        _createElementVNode("p", _hoisted_25, [
          _createElementVNode("a", {
            href: _ctx.url,
            class: "button--small button--primary"
          }, _toDisplayString(_ctx.$t("Common.Checkout")), 9, _hoisted_26)
        ])
      ])
    ], 2)
  ]))
}